import React from 'react';
import { useTranslation } from 'react-i18next';
import { SeasonalPrice } from '../../../hooks/useGetProperty';

interface SeasonalPricesTableProps {
    prices: SeasonalPrice[];
}

const SeasonalPricesTable: React.FC<SeasonalPricesTableProps> = ({ prices }) => {
    const { t } = useTranslation();

    const getPeriodTypeLabel = (type: SeasonalPrice['tipo_periodo']) => {
        switch (type) {
            case 1: return t('rentals.daily', '/ giorno');
            case 2: return t('rentals.weekly', '/ settimana');
            case 3: return t('rentals.biweekly', '/ 15 giorni');
            case 4: return t('rentals.monthly', '/ mese');
            default: return '';
        }
    };

    /**
     * NUOVA FUNZIONE HELPER per formattare il periodo in modo condizionale.
     * Controlla se 'periodo_dal' e 'periodo_al' sono stringhe valide e non vuote.
     * In caso affermativo, costruisce la stringa "dal...al...".
     * Altrimenti, restituisce il valore del campo 'mese'.
     */
    const formatPeriod = (item: SeasonalPrice): string => {
        if (item.periodo_dal && item.periodo_al) {
            return `${item.periodo_dal} - ${item.periodo_al}`;
        }
        return item.mese;
    };


    return (
        <div className="property-description p-4 pt-5 rounded mb-5">
            <h4>{t('rentals.seasonalPricesTitle', 'Prezzi Affitti Stagionali')}</h4>
            <div className="table-responsive">
                <table className="table table-striped table-hover">
                    <thead>
                        <tr>
                            <th>{t('rentals.header.period', 'Periodo')}</th>
                            <th>{t('rentals.header.price', 'Prezzo')}</th>
                            <th className="text-center">{t('rentals.header.availability', 'Disponibilità')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {prices.map((item, index) => (
                            <tr key={index} className={item.affittato === 1 ? 'rented' : ''}>
                                <td>{formatPeriod(item)}</td>
                                <td>
                                    <strong>€ {new Intl.NumberFormat("it-IT").format(item.prezzo)}</strong>
                                    <span className="period-type">{getPeriodTypeLabel(item.tipo_periodo)}</span>
                                </td>
                                <td className="text-center">
                                    {item.affittato === 1 ? (
                                        <span className="badge badge-danger">{t('rentals.rented', 'Affittato')}</span>
                                    ) : (
                                        <span className="badge badge-success">{t('rentals.available', 'Disponibile')}</span>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default SeasonalPricesTable;